<template>
  <div class="Filter" v-click-outside="handleClickOutside">
    <button 
      class="Filter-btn" 
      type="button" 
      @click="isOpen = !isOpen"
      :aria-controls="id" 
      :aria-expanded="isOpen">
      <span class="Filter-btnInner">
        {{label}} {{ selected ? `(${selected})` : '' }} <icon class="Filter-btnIcon" name="keyboard-arrow-down"/>
      </span>
    </button>
    <div class="Filter-dropdown" :id="id" :hidden="!isOpen">
        <checkbox 
          v-for="(option, i) in options" 
          :label="option.label" 
          :value="option.value"
          v-model="modelValue" 
          :key="i"/>
    </div>
  </div>
</template>

<script>
import uniqueId from 'lodash/uniqueId';
import Icon from './Icon.vue';
import Checkbox from './Checkbox.vue';
import { clickOutside } from '../../directives';

export default {
  emits: ['update:modelValue'],

  directives: {
    clickOutside
  },

  components: {
    Icon,
    Checkbox
  },

  data () {
    return {
      id: uniqueId('filter-'),
      isOpen: false
    }
  },

  computed: {
    selected() {
      return this.modelValue.length;
    }
  },

  watch: {
    modelValue() {
      this.$emit('update:modelValue', this.modelValue);
    }
  },

  methods: {
    handleClickOutside() {
      this.isOpen = false;
    },
  },

  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    }
  }
};
</script>